import { render, staticRenderFns } from "./DocumentMain.vue?vue&type=template&id=ce91cba2"
import script from "./DocumentMain.vue?vue&type=script&lang=js"
export * from "./DocumentMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports